<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      title="编辑客户上架模组"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 15 }"
        @submit="handleSubmit"
      >
        <a-form-item label="模组厂商">
          <a-input :value="moduleProducerName" disabled />
        </a-form-item>
        <a-form-item label="模组型号">
          <a-input :value="moduleModelName" disabled />
        </a-form-item>
        <a-form-item label="单价(元/片)">
          <a-input-number
            style="width: 100%"
            :min="0"
            :precision="2"
            :step="0.01"
            v-decorator="['unit_price', {
              rules: [{ required: true, message: '请输入单价' }]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findAgentsModuleProductForm, updateAgentsModuleProduct } from '@/api/agents_module_product'

export default {
  name: 'EditAgentsModuleProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agents_module_product_edit' }),
      submitting: false,
      moduleProducerName: '',
      moduleModelName: ''
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findAgentsModuleProductForm(this.id).then((res) => {
        if (res.code === 0) {
          this.moduleProducerName = res.data.module_producer_name
          this.moduleModelName = res.data.module_model_name
          this.form.setFieldsValue({ unit_price: res.data.unit_price })
        }
      })
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({ title: '请勿重复提交', content: '' })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateAgentsModuleProduct(this.id, values).then((res) => {
            if (res.code === 0) {
              this.isShow = false
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
